<script setup lang="ts">
interface Props {
  title?: string
  variant?: 'info' | 'success' | 'warning' | 'error' | 'white'
  type?: 'info' | 'success' | 'warning' | 'error' | 'white' // Support legacy 'type' prop
}

const props = withDefaults(defineProps<Props>(), {
  variant: 'info'
})

// Use 'type' if provided, otherwise fall back to 'variant'
const alertVariant = props.type || props.variant

const variantClasses = {
  info: 'text-blue-400 border-blue-600',
  success: 'text-green-400 border-green-600',
  warning: 'text-yellow-400 border-yellow-600',
  error: 'text-red-400 border-red-600',
  white: 'text-gray-300 border-gray-500'
}
</script>

<template>
  <div 
    :class="[
      'flex items-center p-3 mb-3 text-sm border rounded-lg',
      variantClasses[alertVariant]
    ]" 
    role="alert"
  >
    <span class="sr-only">{{ alertVariant }}</span>
    <div>
      <span v-if="title" class="font-medium">{{ title }}</span>
      <span v-if="title && $slots.default"> </span>
      <slot></slot>
    </div>
  </div>
</template>